import { useEffect, useRef } from "react";
import { gsap, prefersReducedMotion, revealWords } from "../lib/motion";
import { FEATURES } from "../data/site";
import iconJordan from "../assets/icons/icon-jordan.webp";
import iconTent from "../assets/icons/icon-tent.webp";
import iconBooking from "../assets/icons/icon-booking.webp";
import "./Features.css";

const ICONS = { jordan: iconJordan, tent: iconTent, booking: iconBooking };

export default function Features() {
  const rootRef = useRef(null);

  useEffect(() => {
    const root = rootRef.current;
    if (!root) return undefined;

    const ctx = gsap.context(() => {
      const cards = gsap.utils.toArray(".feature");

      cards.forEach((card, i) => {
        revealWords(card.querySelector(".feature__title"), {
          trigger: card,
          delay: i * 0.08,
          stagger: 0.04,
        });

        if (prefersReducedMotion()) {
          gsap.set(card.querySelectorAll(".feature__medallion, .feature__body"), {
            autoAlpha: 1,
            y: 0,
            scale: 1,
          });
          return;
        }

        gsap.fromTo(
          card.querySelector(".feature__medallion"),
          { autoAlpha: 0, scale: 0.55, y: 26 },
          {
            autoAlpha: 1,
            scale: 1,
            y: 0,
            duration: 1.05,
            ease: "back.out(1.7)",
            delay: i * 0.1,
            scrollTrigger: { trigger: card, start: "top 86%", once: true },
          }
        );

        gsap.fromTo(
          card.querySelector(".feature__body"),
          { autoAlpha: 0, y: 22 },
          {
            autoAlpha: 1,
            y: 0,
            duration: 0.9,
            ease: "power3.out",
            delay: 0.25 + i * 0.1,
            scrollTrigger: { trigger: card, start: "top 86%", once: true },
          }
        );
      });
    }, root);

    return () => ctx.revert();
  }, []);

  return (
    <section className="features section" id="about" ref={rootRef}>
      <div className="container">
        <ul className="features__grid">
          {FEATURES.map((f) => (
            <li className="feature" key={f.id}>
              {/* The reference's own illustrations — kept flat and exact. */}
              <span className="feature__medallion">
                <span className="feature__halo" aria-hidden="true" />
                <img
                  className="feature__icon"
                  src={ICONS[f.icon]}
                  alt=""
                  width="80"
                  height="80"
                  loading="lazy"
                  decoding="async"
                />
              </span>
              <h2 className="feature__title">{f.title}</h2>
              <p className="feature__body">{f.body}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
